import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromAnalysisStrides from './reducers/analysis-strides.reducer';
import { AnalysisStridesService } from './services/analysis-strides.service';
import { AnalysisStridesStoreFacade } from './facades/analysis-strides-store-facade';
import { AnalysisStridesEffects } from './effects/analysis-strides.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromAnalysisStrides.analysisStridesesFeatureKey,
      fromAnalysisStrides.reducer
    ),
    EffectsModule.forFeature([AnalysisStridesEffects]),
  ],
  providers: [AnalysisStridesService, AnalysisStridesStoreFacade],
})
export class AnalysisStridesStoreModule {}
